import type { Addresses } from 'api/types/addresses.types';

export const convertCareemAddressObj = (original: Addresses.CareemAddress): Addresses.Address | null => {
  const {
    type,
    addressId,
    latitude,
    longitude,
    streetName,
    additionalDirections,
    floorNumber,
    city,
    villaNumber,
    savedName,
    buildingName,
    area,
    unitNumber,
    apartmentNumber,
  } = original;

  const commonProps = {
    id: addressId,
    addressType: type,
    lat: JSON.stringify(latitude),
    lng: JSON.stringify(longitude),
    addressText: '',
    geofenceLabel: area || '',
    notes: additionalDirections || '',
    number: floorNumber || '',
    street: streetName || '-',
    lastUsed: false,
    city: city || '',
  };

  switch (type) {
    case 'villa':
      return {
        ...commonProps,
        addressType: 'Villa',
        addressText: villaNumber || '',
        villa: savedName || '',
      };
    case 'office':
      return {
        ...commonProps,
        addressType: 'Office',
        addressText: buildingName || '',
      };
    case 'apartment':
      return {
        ...commonProps,
        addressType: 'Apartment',
        addressText: buildingName || '',
        number: apartmentNumber || '',
      };
    default:
      return {
        ...commonProps,
        addressType: 'Hotel',
        number: unitNumber || '',
        addressText: buildingName || '',
      };
  }
};

export const generateAddressValue = (address = {} as Addresses.Address) => {
  const propertiesToInclude: (keyof Addresses.Address)[] = ['addressType', 'geofenceLabel', 'addressText', 'street', 'villa', 'number'];

  const parts = propertiesToInclude.filter((prop) => address[prop] !== undefined).map((prop) => address[prop]);

  return parts.join(', ');
};
